import { useEffect, useState } from 'react';
import uuid from 'react-uuid';
import { useLang } from '../../../../hooks/useLang';
import { ToolsItem } from './toolsItem/ToolsItem';
import rpa from '../../../../assets/icons/rpa.png';
import ai from '../../../../assets/icons/ai.png';
import cto from '../../../../assets/icons/artificial-intelligence.png';
import dataAnalicys from '../../../../assets/icons/data-analytics.png';
import './tools.css'

export function Tools(){

    const {currentLanguage} = useLang();

    const [title, setTitle] = useState([
        'SERVICES', 'Discover the potential of AI to grow your business'
    ]);

    const [sectionText, setSectionText] = useState([
        ['AI Readiness Architecture', 'Organizational diagnostic: processes, data foundations, culture, and governance readiness.', cto, '01', "Clarity before action"],
        ['AI Transformation Strategy', 'Roadmap aligned with business goals: priorities, milestones, governance model, and delivery plan.', rpa, '02', "Roadmap that executes"],
        ['AI Operating Model Design', 'Human–AI workflows, roles and responsibilities, data governance, and integration into systems.', ai, '03', "From plan to operations"],
        ['Generative AI', 'CAIO advisory and executive governance: ownership, strategic oversight, establishing decision-making processes.', dataAnalicys, '04', "Leadership alignment"]
    ]);

    useEffect(() => {
        if(currentLanguage === 'EN'){
            setSectionText([
                ['AI Readiness Architecture', 'Organizational diagnostic: processes, data foundations, culture, and governance readiness.', cto, '01', "Clarity before action"],
                ['AI Transformation Strategy', 'Roadmap aligned with business goals: priorities, milestones, governance model, and delivery plan.', rpa, '02', "Roadmap that executes"],
                ['AI Operating Model Design', 'Human–AI workflows, roles and responsibilities, data governance, and integration into systems.', ai, '03', "From plan to operations"],
                ['AI Leadership Layer', 'CAIO advisory and executive governance: ownership, strategic oversight, establishing decision-making processes.', dataAnalicys, '04', "Leadership alignment"]
            ]);
            setTitle([
                'SERVICES', 'Discover the potential of AI to grow your business'
            ]);
        }else if(currentLanguage === 'UK'){
            setSectionText([
                ['Архітектура готовності компанії до AI', 'Структурна діагностика організації: процеси, дані, культура, управління та рівень готовності до впровадження AI.', cto, '01', "Розуміння перед діями"],
                ['Стратегія AI-трансформації', 'Дорожня карта, узгоджена з цілями бізнесу: пріоритети, етапи, контрольні точки, модель управління та план реалізації.', rpa, '02', "Стратегія, що виконується"],
                ['Проєктування AI-операційної моделі', 'Модель роботи “людина + AI”: ролі та відповідальність, Human–AI workflow, data governance і інтеграція в наявні системи.', ai, '03', "Від плану до операцій"],
                ['Лідерський рівень AI', 'CAIO advisory та executive governance: ownership, стратегічний контроль і відповідальність на рівні керівництва.', dataAnalicys, '04', "Узгодженість лідерства"]
            ]);
            setTitle([
                'СЕРВІСИ', 'Відкрийте для себе <span>можливості АІ</span> для зростання вашого бізнесу'
            ])
        }
    }, [currentLanguage]);

    return(
        <div className="tools-section">
            <div className='tools-main-container main-container'>
                <h2 className='tools-header'>    
                    <div>
                        <div className='tools-header__vertical-line'>{title[0]}</div>
                        <div className='tools-header__litle-text' dangerouslySetInnerHTML={{__html: title[1]}}></div>
                    </div>
                    
                </h2>
                <div className='tools-inner-container'>
                    {
                        sectionText.map((el, index) => (
                            index % 2 ===  0 
                            ?
                            <ToolsItem data={el} id={uuid()}/>
                            : 
                            null
                        ))
                    }
                </div>
                <div className='tools-inner-container'>
                    {
                        sectionText.map((el, index) => (
                            index % 2 !==  0 
                            ?
                            <ToolsItem data={el} id={uuid()}/>
                            : 
                            null
                        ))
                    }
                </div>
            </div>
        </div>
    );
}